const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function getToken() {
  return localStorage.getItem('auth_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (res.status === 204) return null;
  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
      return;
    }
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || res.statusText);
  }
  return res.json();
}

export const api = {
  // Auth
  login: (email, password) =>
    request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),

  // Current user
  getMe: () => request('/users/me'),
  updateMe: (data) => request('/users/me', { method: 'PATCH', body: JSON.stringify(data) }),
  getMyProjects: () => request('/users/me/projects'),

  // Projects
  getProjects: () => request('/projects'),
  browseProjects: () => request('/projects/browse'),
  createProject: (data) => request('/projects', { method: 'POST', body: JSON.stringify(data) }),
  joinProject: (id) => request(`/projects/${id}/join`, { method: 'POST' }),
  leaveProject: (id) => request(`/projects/${id}/leave`, { method: 'DELETE' }),
  deleteProject: (id) => request(`/projects/${id}`, { method: 'DELETE' }),

  // Suites
  getSuites: (projectId) => request(`/projects/${projectId}/suites`),
  getSuite: (id) => request(`/suites/${id}`),
  createSuite: (data) => request('/suites', { method: 'POST', body: JSON.stringify(data) }),
  updateSuite: (id, data) => request(`/suites/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  moveSuite: (id, parentId) => request(`/suites/${id}/move`, { method: 'POST', body: JSON.stringify({ parent_id: parentId }) }),
  deleteSuite: (id) => request(`/suites/${id}`, { method: 'DELETE' }),
  reorderSuite: (id, direction) => request(`/suites/${id}/reorder`, { method: 'POST', body: JSON.stringify({ direction }) }),

  // Test cases
  getTestCases: (suiteId) => request(`/suites/${suiteId}/test-cases`),
  getTestCase: (id) => request(`/test-cases/${id}`),
  createTestCase: (data) => request('/test-cases', { method: 'POST', body: JSON.stringify(data) }),
  updateTestCase: (id, data) => request(`/test-cases/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  moveTestCase: (id, suiteId) => request(`/test-cases/${id}/move`, { method: 'POST', body: JSON.stringify({ suite_id: suiteId }) }),
  deleteTestCase: (id) => request(`/test-cases/${id}`, { method: 'DELETE' }),
  searchTestCases: (query) => request(`/test-cases/search?query=${encodeURIComponent(query)}`),

  // API Tokens
  listTokens: () => request('/users/me/tokens'),
  createToken: (data) => request('/users/me/tokens', { method: 'POST', body: JSON.stringify(data) }),
  revokeToken: (id) => request(`/users/me/tokens/${id}`, { method: 'DELETE' }),

  // Import
  importFile: (projectId, file, suiteId = null) => {
    const token = getToken();
    const form = new FormData();
    form.append('file', file);
    if (suiteId) form.append('suite_id', suiteId);
    return fetch(`${API}/projects/${projectId}/import`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    }).then((res) => {
      if (!res.ok) return res.json().then((e) => { throw new Error(e.detail || res.statusText); });
      return res.json();
    });
  },
};
